// extracted by mini-css-extract-plugin
export var productList = "index-module--productList--38TOa";
export var seeMore = "index-module--seeMore---atQ7";